import SchedulesList from './SchedulesList';

export default SchedulesList;
